import { Component, Input, OnInit } from '@angular/core';
import { baseUrls } from 'src/app/appConstant';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';

@Component({
  selector: 'app-card-for-instructor',
  templateUrl: './card-for-instructor.component.html',
  styleUrls: ['./card-for-instructor.component.scss']
})
export class CardForInstructorComponent implements OnInit {
  imageUrl = baseUrls.images;
  baseUrl = baseUrls.hostedUrl;
  constructor(public userDashboardService: UserDashboardService) { }

  ngOnInit(): void {
    // console.log('ngOnInit_instructorInfo', this.instructorInfo);
  }

  @Input('instructorInfo')instructorInfo;

  routeToInsructorPage(instructorInfoPassed){
    window.location.href = this.baseUrl+'livewell/instructor/'+instructorInfoPassed?.slug
  }
}
